import { render } from "./Opening.vue?vue&type=template&id=3d2ebb5c&scoped=true&ts=true"
import script from "./Opening.vue?vue&type=script&lang=ts"
export * from "./Opening.vue?vue&type=script&lang=ts"

import "./Opening.vue?vue&type=style&index=0&id=3d2ebb5c&lang=scss&scoped=true"

import exportComponent from "/Users/lxb/kuaike/kunpeng-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d2ebb5c"]])

export default __exports__